const MuiDrawer = {
  styleOverrides: {},
  variants: [{
    props: {
      type: 'underHeader'
    },
    style: {
      zIndex: '1090'
    }
  }]
};
export default MuiDrawer;